export const SAS_META_KEY = 'sas_meta';
export const SAS_META_FACTORIES_KEY = 'sas_meta_factories';
export const SAS_META_PIPES_KEY = 'sas_meta_pipes';
